import { Routes } from '@/router/routes'

import { Middleware } from '@/types/enums/middleware/middleware'

export const dashboardRoutes = [
  {
    path: '/',
    name: Routes.Dashboard,
    component: () => import('@/pages/contexts/portal/dashboard/Index.vue'),
    meta: {
      pageTitle: 'Dashboard',
      middleware: [
        Middleware.REQUIRES_AUTH,
        Middleware.TOGGLES_NAV_DRAWER,
      ],
    },
  },
]
